import React from 'react'
import { PlanetIco } from './Planets'
import { Svg } from './Svg'
import { astroElements, astroInfo, astroSvgs } from '../../static/astro'

export const AstroSign = ({sign = 'Aries', size = 20}) => {
  return (
    <Svg width={size} height={size}>{astroSvgs[sign]}</Svg>
  )
}
export const AstroBg = ({sign = 'Aries', style = {}}) => {
  const getElementColor = (sign) => {
    return astroElements[astroInfo[sign]?.element] || 'transparent';
  }
  return (
    <div 
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        backgroundColor: getElementColor(sign),
        ...style
      }}
    ></div>
  )
}